<div [ngClass]="styleClass">
  <ng-container *ngIf="show">
    <i class="fa fa-exclamation-triangle"></i>
    <span class="message-text">{{errorMessage}}</span>
  </ng-container>
</div>
